<!--
 * @Descripttion: 雷达图组件
 * @Author: zenghua.wang
 * @Date: 2021-10-11 14:53:16
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 17:05:50
 this.dataList = [
  {
    语文: 126,
    数学: 140,
    英语: 130,
    time: '期中成绩'
  },
  {
    语文: 116,
    数学: 134,
    英语: 126,
    time: '期末成绩'
  }
]
-->
<template>
  <div
    ref="container"
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <div
      :ref="id"
      :style="styleChart"
    ></div>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import customLoading from '@/dragComponents/directive/loading'
import echart from '@/dragComponents/mixins/echart'
import { isEmpty, deepClone, isHasProp, setTooltipFormatter } from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-echart-radar',
  mixins: [bem, echart],
  directives: { customLoading },
  data() {
    return {
      component: component
    }
  },
  methods: {
    setOption() {
      const optionData = deepClone(this.optionData)
      let option = {
        title: isHasProp(
          this.option.titleShow,
          {
            text: this.option.titleText,
            subtext: this.option.titleSubtext,
            textStyle: {
              color: this.option.titleTextColor,
              fontSize: this.option.titleTextFontSize * (window?.scale || 1)
            },
            left: this.option.titleLeft || 'auto',
            top: this.option.titleTop || 'auto',
            subtextStyle: {
              color: this.option.titleSubtextColor,
              fontSize: this.option.titleSubtextFontSize * (window?.scale || 1)
            }
          },
          {}
        ),
        tooltip: isHasProp(
          !isEmpty(this.option.tipFormatter),
          {
            formatter: (params) => {
              return setTooltipFormatter(
                this.option.tipFormatter,
                params,
                this.dataList
              )
            }
          },
          {
            show: this.option.tipShow,
            textStyle: {
              fontSize: this.option.tipFontSize,
              color: this.option.tipColor
            }
          }
        ),
        legend: {
          show: this.option.legendShow,
          top: !isEmpty(this.option.legendTop)
            ? this.option.legendTop + '%'
            : 10,
          left: this.option.legendLeft,
          orient: this.option.legendOrient || 'horizontal',
          textStyle: {
            fontSize: this.option.legendFontSize
          },
          data: (() => {
            return optionData.series.map((ele, index) => {
              return {
                name: ele.name,
                textStyle: {
                  color: this.option.legendColor
                }
              }
            })
          })()
        },
        radar: {
          center: [this.option.centerX + '%', this.option.centerY + '%'],
          radius: this.option.centerR + '%',
          shape: this.option.shape,
          name: {
            fontSize: this.option.nameFontSize,
            color: this.option.nameColor
          },
          indicator: optionData.indicators
        },
        series: (() => {
          const list = [
            {
              type: this.option.type,
              data: (() => {
                return optionData.series.map((ele, index) => {
                  return {
                    name: ele.name,
                    value: ele.value,
                    label: {
                      show: this.option.labelShow,
                      textStyle: {
                        fontSize: this.option.labelShowFontSize,
                        color: this.option.labelShowColor,
                        fontWeight: this.option.labelShowFontWeight
                      },
                      formatter: ({ value }) => {
                        return !isEmpty(this.option.unit)
                          ? value + this.option.unit
                          : value
                      }
                    },
                    areaStyle: {
                      opacity: this.option.areaOpacity
                    }
                  }
                })
              })()
            }
          ]
          return list
        })()
      }

      // 颜色设置
      if (this.option.defaultColor) {
        option.color && delete option.color
      } else {
        option.color = this.option.color
      }

      // console.log('setOption==', option)
      this.dragChart.resize()
      this.dragChart.setOption(option, true)
      this.isChart = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init(mock.echart.radar.data, [], mock.echart.radar.indicator)
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/echart/index.scss';
</style>

